import { render, staticRenderFns } from "./SubtitlesControlHorizontal.vue?vue&type=template&id=3d22d3f8&scoped=true"
import script from "./SubtitlesControlHorizontal.vue?vue&type=script&lang=js"
export * from "./SubtitlesControlHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d22d3f8",
  null
  
)

/* custom blocks */
import block0 from "./SubtitlesControlHorizontal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports